import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import { MainContextProvider } from "./context/OpenInvoice";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import MainComp from "./page/LinkComp";
import GoodUrl from "./page/GoodUrl";
import ErrorUrl from "./page/ErrorUrl";
import Accessibility from "./page/Accessibility";
import AuthorizationPage from "./page/AuthorizationPortal";
import AdminList from "./page/Roles";
import { RolesContextProvider } from "./context/User";
import AllInvoice from "./page/AllInvoices";
import OpenOrders from "./page/OpenOrders";
import Error from "./page/ErrorMessage";
import AboutInfoPage from "./page/AboutInfo";
import ShippingInvoice from "./page/ShippingInvoice";
import FilePiorty from "./page/FileUpload";
import HomePagecard from "./component/HomePage/HomePageCard";
import MainCustomCard from "./styleComp/MainCustomCard";
import InvoiceList2 from "./page/OpenInvoice2";
import SuccessfulPage from "./eldanqrcode/Components/SuccessfulPage";
import HomePageEldan from "./eldanqrcode/Components/HomePage";
import DeviceLookup from "./eldanqrcode/Components/DeviceLookup";
import NursinghomePage from "./component/Nursinghome/NursinghomePage";
import NursingHomeOrderConfirmation from "./component/Nursinghome/NursingHomeOrderConfirmation";
import NursingHomeOrderHistory from "./component/Nursinghome/NursingHomeOrderHistory";
import ChemoRecordsPage from "./page/ChemoRecords";
import { UserProvider } from "./contexts/UserContext";



const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: ["Varela Round", "sans-serif"].join(","),
  },
});

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const appStyles = {
  backgroundColor: "white",
};

function App() {
  
  return (
    <>
      <MainContextProvider>
        <RolesContextProvider>
          <UserProvider>
          <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
              <div className="App" dir="rtl" style={appStyles}>
                <BrowserRouter>
                  <MainCustomCard>
                    <Routes>
                      <Route
                        path="/authorization/:encode"
                        element={<MainComp />}
                      />
                      <Route
                        path="/linkopeninvoice"
                        element={<InvoiceList2 />}
                      />
                      <Route path="/url_good" element={<GoodUrl />} />
                      <Route path="/error" element={<ErrorUrl />} />
                      <Route path="/" element={<AuthorizationPage />} />
                      <Route path="/portal" element={<HomePagecard />} />
                      <Route path="/about" element={<AboutInfoPage />} />
                      <Route path="/getinvoice" element={<AllInvoice />} />
                      <Route path="/roles" element={<AdminList />} />
                      <Route path="/openorder" element={<OpenOrders />} />
                      <Route path="/errormessage" element={<Error />} />
                      <Route path="/shipping" element={<ShippingInvoice />} />
                      <Route path="/fileupload" element={<FilePiorty />} />
                      <Route
                        path="/accessibility-statement"
                        element={<Accessibility />}
                      />
                      <Route path="/nursinghome" element={<NursinghomePage />} />
                      <Route path="/nursinghome/confirm" element={<NursingHomeOrderConfirmation />} />
                      <Route path="/nursinghome/history" element={<NursingHomeOrderHistory />} />
                      <Route path="/chemo" element={<ChemoRecordsPage />} />

                      {/* routes for eldanqrcode */}
                      <Route path="/device" element={<DeviceLookup />} />
                      <Route
                        path="/device/:encode"
                        element={<HomePageEldan />}
                      />
                      <Route path="/successful" element={<SuccessfulPage />} />


                    </Routes>
                  </MainCustomCard>
                </BrowserRouter>
              </div>
            </ThemeProvider>
          </CacheProvider>
          </UserProvider>
        </RolesContextProvider>
      </MainContextProvider>
    </>
  );
}

export default App;
